var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _polygon, _polygon2, _circle4, _rect33, _rect34, _polygon3, _polygon4, _circle5, _path8, _path9, _path0, _rect35, _rect36, _rect37, _rect38, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _rect39, _path1, _path10, _rect40, _circle6, _path11, _polygon0, _polygon1, _polygon10, _path12, _path13, _path14, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _path15, _path16, _circle7, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle8, _path24, _path25, _path26, _polygon11, _polygon12, _polygon13, _polygon14, _path27, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea61258a-e793-48f7-8624-3c5ca462ffd9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.3 779",
    style: {
      enableBackground: "new 0 0 882.3 779"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6E6E6;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#CCCCCC;}\r\n\t.st3{fill:#0B51B7;}\r\n\t.st4{fill:#3F3D56;}\r\n\t.st5{fill:#6C63FF;}\r\n\t.st6{fill:#2F2E41;}\r\n\t.st7{fill:#FFB8B8;}\r\n\t.st8{fill:#575A89;}\r\n\t.st9{opacity:0.2;enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.4,20.1l3.5-5.4c-1-2.8-2.2-5.6-3.6-8.3L340,8.2l1.8-2.7c-1.7-3.3-3-5.4-3-5.4s-7,11-9.3,22.6l4.5,6.9 l-4.9-4c-0.2,1.4-0.3,2.7-0.3,4.1c0,13.7,4.5,24.9,10,24.9s10-11.1,10-24.9c-0.1-4.4-0.9-8.7-2.3-12.8L342.4,20.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.9,32l6.2-1.3c1.3-2.7,2.4-5.5,3.4-8.4l-2.9-0.3l3.2-0.7c1.2-3.6,1.7-6,1.7-6s-12.7,2.8-22.5,9.4l-1.7,8 l-0.7-6.3c-1.1,0.8-2.1,1.7-3.1,2.7c-9.7,9.7-14.4,20.8-10.5,24.7s15-0.8,24.7-10.5c3-3.2,5.5-6.8,7.5-10.7L366.9,32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.2,85.2c-14.5,0.9-30.3-0.1-47,0V46.8c14.8,2.3,30.6,2.1,47,0V85.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.8,115.2l2.3-3.5c-0.7-1.9-1.4-3.7-2.3-5.4l-1.5,1.2l1.2-1.8c-1.1-2.2-2-3.5-2-3.5 c-2.8,4.6-4.8,9.5-6.1,14.7l2.9,4.5l-3.2-2.6c-0.1,0.9-0.2,1.8-0.2,2.7c0,9,2.9,16.2,6.5,16.2s6.5-7.3,6.5-16.2 c-0.1-2.9-0.6-5.7-1.5-8.4L472.8,115.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M488.8,122.9l4.1-0.9c0.8-1.8,1.6-3.6,2.2-5.5l-1.9-0.2l2.1-0.4c0.8-2.3,1.1-3.9,1.1-3.9 c-5.2,1.2-10.2,3.3-14.7,6.1l-1.1,5.2l-0.4-4.1c-0.7,0.5-1.4,1.1-2,1.8c-6.3,6.3-9.4,13.6-6.9,16.1s9.8-0.5,16.1-6.9 c2-2.1,3.6-4.4,4.9-7L488.8,122.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.3,157.6c-9.4,0.6-19.7,0-30.7,0v-25.1c10.2,1.4,20.5,1.4,30.7,0V157.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.5,231.9c-8.3,0.5-17.4,0-27.1,0v-22.1c9,1.3,18.1,1.3,27.1,0V231.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 82.5,
    className: "st0",
    width: 364.5,
    height: 10.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 154.8,
    className: "st0",
    width: 364.5,
    height: 10.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 227.1,
    className: "st0",
    width: 364.5,
    height: 10.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 471,
    cy: 197.5,
    r: 20.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 471,
    cy: 197.5,
    r: 16.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 471,
    cy: 197.5,
    r: 4.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 468.9,
    y: 196.5,
    className: "st0",
    width: 16.3,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 469.9,
    y: 183.3,
    className: "st0",
    width: 2,
    height: 16.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 339.7,
    y: 105.1,
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 339.7,
    y: 113.5,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 339.7,
    y: 140.5,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 105.1,
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 113.5,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 140.5,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 363.9,
    y: 105.1,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -19.9904 178.1151)",
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 357.1,
    y: 115.1,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -14.6609 173.7203)",
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 369.1,
    y: 139.3,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -24.1356 181.5332)",
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 177.4,
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 185.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 212.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 198.8,
    y: 177.4,
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 198.8,
    y: 185.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 198.8,
    y: 212.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 243.7,
    y: 177.4,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -64.5434 132.3081)",
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 187.4,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -59.2139 127.9134)",
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 248.9,
    y: 211.6,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -68.6885 135.7263)",
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 345.8,
    y: 177.4,
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 345.8,
    y: 185.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 345.8,
    y: 212.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 325.1,
    y: 177.4,
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 325.1,
    y: 185.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 325.1,
    y: 212.8,
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 177.4,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -51.4343 188.3319)",
    className: "st0",
    width: 13.5,
    height: 53.3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 363.3,
    y: 187.4,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -46.1048 183.9371)",
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 375.2,
    y: 211.6,
    transform: "matrix(0.8962 -0.4437 0.4437 0.8962 -55.5794 191.7501)",
    className: "st2",
    width: 13.5,
    height: 6.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 32.6,
    className: "st0",
    width: 53.6,
    height: 53.6
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 460.7,
    y: 43.4,
    className: "st2",
    width: 32.1,
    height: 32.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "470,54.1 476.8,65.9 483.6,77.7 470,77.7 456.4,77.7 463.2,65.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "481.8,56.4 488.7,68.2 495.5,80 481.8,80 468.2,80 475,68.2 "
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 486.6,
    cy: 49,
    r: 3.9
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 179.1,
    y: 32.6,
    className: "st0",
    width: 53.6,
    height: 53.6
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 189.8,
    y: 43.4,
    className: "st2",
    width: 32.1,
    height: 32.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "199.1,54.1 205.9,65.9 212.8,77.7 199.1,77.7 185.5,77.7 192.3,65.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "211,56.4 217.8,68.2 224.6,80 211,80 197.3,80 204.2,68.2 "
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 215.8,
    cy: 49,
    r: 3.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.5,397.8l3.5-5.4c-1-2.8-2.2-5.6-3.6-8.3l-2.2,1.8l1.8-2.7c-1.7-3.3-3-5.4-3-5.4s-7,11-9.3,22.6l4.5,6.9 l-4.9-4c-0.2,1.4-0.3,2.7-0.3,4.1c0,13.7,4.5,24.9,10,24.9s10-11.1,10-24.9c-0.1-4.4-0.9-8.7-2.3-12.8L71.5,397.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.1,409.8l6.2-1.3c1.3-2.7,2.4-5.5,3.4-8.4l-2.9-0.3l3.2-0.7c1.2-3.6,1.7-6,1.7-6s-12.7,2.8-22.5,9.4l-1.7,8 l-0.7-6.3c-1.1,0.8-2.1,1.7-3.1,2.7c-9.7,9.7-14.4,20.8-10.5,24.7s15-0.8,24.7-10.5c3-3.2,5.5-6.8,7.5-10.7L96.1,409.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.3,463c-14.5,0.9-30.3-0.1-47,0v-38.4c14.8,2.3,30.6,2.1,47,0V463z"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 475,
    className: "st0",
    width: 195.5,
    height: 253.6
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 488.3,
    className: "st0",
    width: 10.2,
    height: 240.3
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    y: 457.7,
    className: "st0",
    width: 696.5,
    height: 20.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 87.6,
    y: 478.1,
    className: "st0",
    width: 20.4,
    height: 20.4
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "614.2,489.8 613,494.4 584.5,494.4 582.8,489.8 510.2,489.8 510.2,536.6 687.3,536.6 687.3,489.8 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "614.2,548.9 613,553.4 584.5,553.4 582.8,548.9 510.2,548.9 510.2,595.7 687.3,595.7 687.3,548.9 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "614.2,607.9 613,612.5 584.5,612.5 582.8,607.9 510.2,607.9 510.2,654.8 687.3,654.8 687.3,607.9 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "614.2,667 613,671.6 584.5,671.6 582.8,667 510.2,667 510.2,713.8 687.3,713.8 687.3,667 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "377.8,454.7 317.7,454.7 319.7,428.2 375.7,428.2 "
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 314.7,
    y: 451.6,
    className: "st0",
    width: 67.2,
    height: 6.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M462.8,257.6H233.2c-3.4,0-6.1,2.7-6.1,6.1v0v140h241.8v-140C468.9,260.4,466.2,257.6,462.8,257.6L462.8,257.6z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.1,403.8v22.9c0,3.4,2.7,6.1,6.1,6.1h0h229.6c3.4,0,6.1-2.7,6.1-6.1v0v-22.9H227.1z"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 239.3,
    y: 270.4,
    className: "st1",
    width: 217.9,
    height: 122.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 348.3,
    cy: 418,
    r: 6.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M865,727.1c-22.3,1.4-46.5-0.1-72.3,0V668c22.7,3.5,47,3.2,72.3,0V727.1z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "831.4,673.3 825.3,673.3 827.4,553.9 829.4,553.9 "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "858.9,674.1 852.8,674.1 854.9,554.8 856.9,554.8 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "807,674.1 800.9,674.1 802.9,554.8 805,554.8 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M836.5,477.6l9.9-15.2c-2.9-8.1-6.3-16-10.1-23.7l-6.4,5.2l5-7.8c-4.8-9.5-8.6-15.4-8.6-15.4 s-19.8,31.2-26.4,64.2l12.7,19.6l-14-11.3c-0.5,3.8-0.8,7.7-0.8,11.6c0,39.1,12.8,70.8,28.5,70.8s28.5-31.7,28.5-70.8 c0-12.1-2.7-24.8-6.5-36.5L836.5,477.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M864,479.6l9.9-15.2c-2.9-8.1-6.3-16-10.1-23.7l-6.4,5.2l5-7.8c-4.8-9.5-8.6-15.4-8.6-15.4 s-19.8,31.2-26.4,64.2l12.7,19.6l-14-11.3c-0.5,3.8-0.8,7.7-0.8,11.6c0,39.1,12.8,70.8,28.5,70.8s28.5-31.7,28.5-70.8 c0-12.1-2.7-24.8-6.5-36.5L864,479.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M812.1,479.6l9.9-15.2c-2.9-8.1-6.3-16-10.1-23.7l-6.4,5.2l5-7.8c-4.8-9.5-8.6-15.4-8.6-15.4 s-19.8,31.2-26.4,64.2l12.7,19.6l-14-11.3c-0.5,3.8-0.8,7.7-0.8,11.6c0,39.1,12.8,70.8,28.5,70.8s28.5-31.7,28.5-70.8 c0-12.1-2.7-24.8-6.5-36.5L812.1,479.6z"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 304.8,
    className: "st4",
    width: 58.8,
    height: 3.4
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 317.2,
    className: "st3",
    width: 90.7,
    height: 3.4
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 328.7,
    className: "st5",
    width: 73.9,
    height: 3.4
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 340.3,
    className: "st4",
    width: 43.2,
    height: 3.4
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 351.8,
    className: "st4",
    width: 65.2,
    height: 3.4
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 303.6,
    className: "st4",
    width: 7.2,
    height: 7.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 315.2,
    className: "st3",
    width: 7.2,
    height: 7.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 326.8,
    className: "st5",
    width: 7.2,
    height: 7.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 338.4,
    className: "st4",
    width: 7.2,
    height: 7.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 350,
    className: "st4",
    width: 7.2,
    height: 7.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M447.1,298.5h-30.8c-2.1-12.2-2.1-24.6,0-36.8h30.8C443.6,273.7,443.4,286.5,447.1,298.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.8,372.1l-12.7-3.1c-18,0-32.7-14.6-32.7-32.6c0-2.2,0.2-4.4,0.6-6.5l0,0c0-23.6,19.1-42.7,42.6-42.7h0 c23.6,0,42.7,19.1,42.7,42.6v0C270.6,354.8,248.1,378.3,222.8,372.1z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 236.6,
    cy: 345.2,
    r: 31.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M216.2,361.6c0,0-9.5,32.7-15,35.5s43.6,6.8,43.6,6.8s-1.4-31.4,1.4-34.1S216.2,361.6,216.2,361.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.3,563.4c0,0,61.4-5.5,69.5,15s-5.5,141.8-5.5,141.8h-25.9v-99.5c0,0-110.5-31.4-110.5-42.3 S265.3,563.4,265.3,563.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M325.3,714.8l13.6,5.5c0,0,16.4-1.4,9.5,10.9c-4,7.2-11,12.2-19.1,13.6c0,0-25.9,9.5-27.3,0s6.8-28.6,6.8-28.6 L325.3,714.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.2,563.4c0,0,61.4-5.5,69.5,15s-5.5,141.8-5.5,141.8h-25.9v-99.5c0,0-78.4-18.2-78.4-29.1 c0-5.1-5.3-31.2,4.1-36.7C205.6,548.8,231.2,563.4,231.2,563.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291.2,714.8l13.6,5.5c0,0,16.4-1.4,9.5,10.9c-4,7.2-11,12.2-19.1,13.6c0,0-25.9,9.5-27.3,0s6.8-28.6,6.8-28.6 L291.2,714.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202.5,393l41,4.5c13,1.4,23.6,11,26.3,23.8l15.9,75.4c0,0,5.5,75-5.5,79.1s-25.9-16.4-46.4-13.6 s-47,8.9-47,8.9s-4.2-134.2-4.8-145.2C181,403.7,202.5,393,202.5,393z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.6,567.3l16.8,9.9c0,0,30.2-4.3,29.2,6.3s-33.9,8.6-33.9,8.6l-20.3-12.5L299.6,567.3z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 175.7,
    cy: 299.5,
    r: 20.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194.4,288.6c0-11.2-9.1-20.2-20.3-20.2c-1.3,0-2.7,0.1-4,0.4c10.1-4.8,22.2-0.5,27,9.7 c4.8,10.1,0.5,22.2-9.7,27c-1.5,0.7-3.1,1.2-4.7,1.5C189.9,303.6,194.4,296.4,194.4,288.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,300.1l27.3-5l21,13.2c10.5,6.6,16.3,18.8,14.7,31.1l-21-5.3l-4.7-11.8l-5.6,9.2l-29.3,37.8l-16.5-10.5 l-14.7-23L211.8,300.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.3,404.6l13.6-6.8c0,0,28.6,4.1,34.1,23.2s30,151.4,30,151.4l-23.2,10.9l-32.7-80.5L234.3,404.6z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "245.9,458.2 259.6,511.2 283.8,570.7 282.9,572.8 254.1,512.2 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "144.1,750.4 139.3,748.7 185.9,610.2 192.6,612.6 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "322.3,750.4 327.1,748.7 280.5,610.2 273.7,612.6 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,779 228.9,779 230.4,617.1 223.3,617.1 "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.3,528.9l14,56.4c4,16.1,16.5,28.7,32.6,32.7h0c38.9,9.7,79.7,9.5,118.5-0.8l20.9-5.5 c12.1-3.2,21.2-13.6,22.1-26.1c0.3-4.4-0.5-8.9-2.3-12.9c-0.1-0.2-0.2-0.3-0.2-0.5c-5.5-11.4-16.9-18.8-29.6-19.1l-22.1-0.7 l-80.4-35.6c0,0-27.7-14.1-50.4-15.6C140.3,500.1,128.7,514.2,132.3,528.9z"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 543.3,
    y: 351.3,
    className: "st0",
    width: 79.4,
    height: 107.9
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 552.4,
    y: 363.8,
    className: "st1",
    width: 61.1,
    height: 83
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 576.5,
    y: 385.5,
    className: "st4",
    width: 29.6,
    height: 3.4
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 559.9,
    y: 383.6,
    className: "st4",
    width: 7.2,
    height: 7.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 576.5,
    y: 399.7,
    className: "st4",
    width: 29.6,
    height: 3.4
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 559.9,
    y: 397.9,
    className: "st4",
    width: 7.2,
    height: 7.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 576.5,
    y: 414,
    className: "st4",
    width: 29.6,
    height: 3.4
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 559.9,
    y: 412.1,
    className: "st4",
    width: 7.2,
    height: 7.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M583,354.4L583,354.4c1.7,0,3.1,1.4,3.1,3.1l0,0c0,1.7-1.4,3.1-3.1,3.1l0,0c-1.7,0-3.1-1.4-3.1-3.1l0,0 C579.9,355.7,581.3,354.4,583,354.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.be0c8f1c1c08a3cac2baaab466745bc9.svg";
export { ForwardRef as ReactComponent };